'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('@material-ui/core/styles');

var _core = require('@material-ui/core');

var _Typography = require('../Typography');

var _form = require('../../schema/component/form.json');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */


var schema = _form.properties.radio.properties;

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      alignItems: function alignItems(_ref) {
        var _alignItems = _ref.alignItems;
        return _alignItems;
      },
      display: function display(_ref2) {
        var _display = _ref2.display;
        return _display;
      }
    },
    radio: {
      margin: '-9px',
      '&.Mui-checked': {
        color: 'var(--secondary-700)'
      }
    },
    label: {
      marginLeft: '8px'
    }
  };
});

var Radio = function Radio(_ref3) {
  var variant = _ref3.variant,
      label = _ref3.label,
      labelVariant = _ref3.labelVariant,
      checked = _ref3.checked,
      onChange = _ref3.onChange,
      radioProps = _ref3.radioProps,
      props = _objectWithoutProperties(_ref3, ['variant', 'label', 'labelVariant', 'checked', 'onChange', 'radioProps']);

  var variantDefault = schema.default.properties;
  var variantSelected = schema[variant] && schema[variant].properties;
  var variantValidation = variantSelected || variantDefault;
  var classes = useStyles(variantValidation);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      checkedState = _useState2[0],
      setCheckedState = _useState2[1];

  var onChangeState = function onChangeState() {
    return setCheckedState(!checkedState);
  };

  return _react2.default.createElement(
    'div',
    _extends({ className: classes.root }, props),
    _react2.default.createElement(_core.Radio, _extends({}, radioProps, {
      className: classes.radio,
      checked: checked || checkedState,
      onChange: onChange || onChangeState,
      onClick: onChange || onChangeState
    })),
    variantValidation.isLabel && _react2.default.createElement(_Typography.Typography, {
      variant: labelVariant,
      dangerouslySetInnerHTML: { __html: label },
      className: classes.label
    })
  );
};

exports.Radio = Radio;
Radio.defaultProps = {
  checked: schema.props.properties.checked,
  radioProps: schema.props.properties.radioProps,
  label: schema.props.properties.label,
  labelVariant: schema.props.properties.labelVariant,
  onChange: schema.props.properties.onChange,
  variant: schema.props.properties.variant
};

Radio.propTypes = {
  checked: _propTypes2.default.bool,
  radioProps: _propTypes2.default.shape({}),
  label: _propTypes2.default.string,
  labelVariant: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  variant: _propTypes2.default.string
};

exports.default = Radio;